import React, {useEffect, useState} from "react";
import styled from 'styled-components';

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 40%;
  margin: auto;
  background-color: aliceblue;
`;

const StyledH1 = styled.h1`
  text-align: center;
  padding: 2vh;
  color: yellow ;
  background-color: darkgreen;
  font-size: calc( 2px + 3vw);
`

const StyledH2 = styled.h2`
  color: darkred;
  text-align: center;
`

const StyledH3 = styled.h3`
  text-align: center;
`

const StyledH5 = styled.h5`
  text-align: center;
`

export default function LabElevenC(){
    const [data, setData] = useState([]);
    useEffect(() => {
        async function fetchData(){
            const rawData = await fetch("https://rickandmortyapi.com/api/character");
            const {results} = await rawData.json();
            setData(results);
        }

        fetchData()
            .then((r) => console.log("Data fetched successfully"))
            .catch((e) => console.log("There was an error"));

    },[]);
    return(
        <>
            {
                data.map((i) =>
                    (
                        <StyledDiv key = {i.id}>
                            <StyledH1>{i.name}</StyledH1>
                            <StyledH3>{i.species}</StyledH3>
                            <StyledH5>{i.gender}</StyledH5>
                            <StyledH5>{i.origin.name}</StyledH5>
                            <img src={i.image} alt={"Rick and Morty character"}/>
                            {i.status !== "Alive" && <StyledH2>Not Alive!</StyledH2>}
                        </StyledDiv>
                    ))
            }
        </>
    );
}
